import React, {PureComponent, ReactNode} from 'react';
import PrizeCard from 'app/components/reusable/PrizeCard';
import {type ArtifactLike} from 'app/utils/artifactToLoot';

interface SmileItem extends Omit<ArtifactLike, 'image'> {
    filename?: string;
    image?: ArtifactLike['image'] | {url: string | null};
}

interface Props {
    smiles?: SmileItem[];
}

export default class Smiles extends PureComponent<Props> {
    render(): ReactNode {
        const {smiles = []} = this.props;

        if (smiles.length === 0) {
            return null;
        }

        return <div className="prize-card-grid inventory__popup--smiles">
            {smiles.map((smile: SmileItem, index: number) => <PrizeCard
                key={`smile-${index}`}
                artifact={smile as ArtifactLike}
                hideMeta
                hideName
            />)}
        </div>;
    }
}
